import { AtcProduct } from "@/types/atc";
import { PRODUCT_IMAGES } from "@/utils/imagesMap";
import { PRODUCT_IMAGES_CORE } from "@/utils/imagesMapCore";

export const PRODUCT_TYPES: {
  WOMEN: AtcProduct;
  BALANCE: AtcProduct;
  POSTPARTUM: AtcProduct;
  MEN: AtcProduct;
  MEN50: AtcProduct;
  [key: string]: AtcProduct;
} = {
  WOMEN: {
    id: "Women",
    longId: "Women",
    img: PRODUCT_IMAGES_CORE.ADV3.label2,
    img1: PRODUCT_IMAGES_CORE.ADV1.label1,
    dropdownImg: PRODUCT_IMAGES_CORE.ADV1.label2,
    label: PRODUCT_IMAGES_CORE.ADV3.label0,
    name: "Women's Hair Growth Supplements",
    headline: "Hair Growth Nutraceutical",
    subtext: "For women 18-44.",
    description:
      "Our daily hair growth supplement is made for women 18-44 who are experiencing signs of hair thinning.",
    optionSkus: ["ADV1", "ADV3", "ADV6"],
    pdp: "/hair/women/product/core/women-advanced/",
  },
  BALANCE: {
    id: "Balance",
    longId: "Women’s Balance",
    img: PRODUCT_IMAGES_CORE.BAL3.label2,
    img1: PRODUCT_IMAGES_CORE.BAL1.label1,
    dropdownImg: PRODUCT_IMAGES_CORE.BAL1.label2,
    label: PRODUCT_IMAGES_CORE.BAL3.label0,
    name: "Balance for Women 45+",
    headline: "Hair Growth Nutraceutical",
    subtext: "For women 45+.",
    description:
      "Our physician-formulated hair growth supplement is designed for women 45+ experiencing hair thinning due to hormonal changes like menopause.",
    optionSkus: ["BAL1", "BAL3", "BAL6"],
    pdp: "/hair/women/product/core/balance/",
  },
  POSTPARTUM: {
    id: "Postpartum",
    longId: "Postpartum",
    img: PRODUCT_IMAGES_CORE.POS3.label2,
    img1: PRODUCT_IMAGES_CORE.POS1.label1,
    dropdownImg: PRODUCT_IMAGES_CORE.POS1.label2,
    label: PRODUCT_IMAGES_CORE.POS3.label0,
    name: "Postpartum Hair Growth Supplements",
    headline: "Hair Growth Nutraceutical",
    subtext: "For women in the first year post-childbirth.",
    description:
      "A daily hair growth supplement for postpartum women in the first year after giving birth or breastfeeding.",
    optionSkus: ["POS1", "POS3", "POS6"],
    pdp: "/hair/women/product/core/postpartum/",
  },
  MEN: {
    id: "Men",
    longId: "Men",
    img: PRODUCT_IMAGES_CORE.MENPRO3.label2,
    img1: PRODUCT_IMAGES_CORE.MENPRO1.label1,
    dropdownImg: PRODUCT_IMAGES_CORE.MENPRO1.label2,
    label: PRODUCT_IMAGES_CORE.MENPRO3.label0,
    name: "Men's Hair Growth Supplements",
    headline: "Hair Growth Nutraceutical",
    subtext: "For men ages 18-49.",
    description:
      "Our daily hair growth supplement for men with shedding and decreased scalp coverage who want to take a proactive approach to hair thinning.",
    optionSkus: ["MENPRO1", "MENPRO3", "MENPRO6"],
    optionImages: [
      PRODUCT_IMAGES_CORE.MENPRO1.label2,
      PRODUCT_IMAGES_CORE.MENPRO3.label2,
      PRODUCT_IMAGES_CORE.MENPRO6.label2,
    ],
    pdp: "/hair/men/product/core/men/",
  },
  MEN50: {
    id: "Men 50+",
    longId: "Men 50+",
    img: PRODUCT_IMAGES_CORE.MSR3.label2,
    img1: PRODUCT_IMAGES_CORE.MSR1.label1,
    dropdownImg: PRODUCT_IMAGES_CORE.MSR1.label2,
    label: PRODUCT_IMAGES_CORE.MSR3.label0,
    name: "Men 50+ Hair Growth Supplements",
    headline: "Hair Growth Nutraceutical",
    subtext: "For men 50+.",
    description:
      "Our clinically-proven daily hair growth supplement helps men experiencing hair thinning grow visibly thicker hair. ",
    optionSkus: ["MSR1", "MSR3", "MSR6"],
    optionImages: [
      PRODUCT_IMAGES_CORE.MSR1.label7,
      PRODUCT_IMAGES_CORE.MSR3.label3,
      PRODUCT_IMAGES_CORE.MSR6.label3,
    ],
    pdp: "/hair/men/product/core/men50/",
  },
  ADVGSML1: {
    id: "Women",
    longId: "Women",
    img: PRODUCT_IMAGES.ADVGSML1.label4,
    dropdownImg: PRODUCT_IMAGES_CORE.ADV1.label2,
    label: PRODUCT_IMAGES.ADVGSML1.label0,
    name: "Women",
    headline: "Fullest Hair Kit",
    subtext: "For women 18–44.",
    description:
      "A physician-formulated regimen for your hair health, including a daily supplement clinically tested to improve hair growth from within by addressing key root causes of hair thinning and a hair serum to target areas of concern directly at the scalp to visibly reduce hair fall caused by breakage for overall visibly thicker, fuller hair.",
    optionSkus: ["ADVGSML1", "ADVGSML3"],
    optionImages: [PRODUCT_IMAGES.ADVGSML1.label4, PRODUCT_IMAGES.ADVGSML3.label4],
    bullets: ["Hair Growth Nutraceutical", "Hair Serum"],
  },
  BALGSML1: {
    id: "Women's Balance",
    longId: "Women's Balance",
    img: PRODUCT_IMAGES.BALGSML1.label4,
    dropdownImg: PRODUCT_IMAGES_CORE.BAL1.label2,
    label: PRODUCT_IMAGES.BALGSML1.label0,
    name: "Women's Balance",
    headline: "Fullest Hair Kit",
    subtext: "For women 45+.",
    description:
      "A physician-formulated regimen for your hair health, including a daily supplement clinically tested to improve hair growth from within by addressing key root causes of hair thinning and a hair serum to target areas of concern directly at the scalp to visibly reduce hair fall caused by breakage for overall visibly thicker, fuller hair.",
    optionSkus: ["BALGSML1", "BALGSML3"],
    optionImages: [PRODUCT_IMAGES.BALGSML1.label4, PRODUCT_IMAGES.BALGSML3.label4],
    bullets: ["Hair Growth Nutraceutical", "Hair Serum"],
  },
  POSGSML1: {
    id: "Postpartum",
    longId: "Postpartum",
    img: PRODUCT_IMAGES.POSGSML1.label4,
    dropdownImg: PRODUCT_IMAGES_CORE.POS1.label2,
    label: PRODUCT_IMAGES.POSGSML1.label0,
    name: "Postpartum",
    headline: "Fullest Hair Kit",
    subtext: "For women in the first year post-childbirth.",
    description:
      "A physician-formulated regimen for your hair health, including a daily supplement clinically tested to improve hair growth from within by addressing key root causes of hair thinning and a hair serum to target areas of concern directly at the scalp to visibly reduce hair fall caused by breakage for overall visibly thicker, fuller hair.",
    optionSkus: ["POSGSML1", "POSGSML3"],
    optionImages: [PRODUCT_IMAGES.POSGSML1.label4, PRODUCT_IMAGES.POSGSML3.label4],
    bullets: ["Hair Growth Nutraceutical", "Hair Serum"],
  },
  HAIRSERUMSML: {
    id: "Hair Serum",
    img: PRODUCT_IMAGES.HAIRSERUMSML.label3,
    label: PRODUCT_IMAGES.HAIRSERUMSML.label0,
    name: "Hair Serum",
    subtext:
      "A physician-formulated and award winning serum. Reduce hair shedding while replenishing nutrients directly at the scalp for visibly fuller, thicker hair. 100% drug-free and microbiome friendly.",
    optionSkus: ["HAIRSERUMSML"],
  },
  STRANDSERUM: {
    id: "Strand Serum",
    img: PRODUCT_IMAGES.STRANDSERUM.label1,
    label: PRODUCT_IMAGES.STRANDSERUM.label0,
    name: "Strand Serum",
    subtext:
      "Physician-formulated with our patent-pending DualFusion™ Complex, this shake-activated serum unites a replenishing oil phase and a strengthening water phase to protect thinning strands, helping reduce breakage by 64%<sup>2</sup> for stronger hair that can grow longer.",
    optionSkus: ["STRANDSERUM"],
  },
  MHAIRSERUMSML: {
    id: "Hair Serum",
    img: PRODUCT_IMAGES.MHAIRSERUMSML.label2,
    label: PRODUCT_IMAGES.MHAIRSERUMSML.label0,
    name: "Men’s Hair Serum",
    subtext:
      "A lightweight, drug-free hair serum with patent-pending Ashwagandha Exosomes replenishes nutrients directly at the scalp to support visible density and stronger-feeling hair.",
    optionSkus: ["MHAIRSERUMSML"],
  },
};

export const productData: AtcProduct[] = [
  { ...PRODUCT_TYPES.WOMEN },
  { ...PRODUCT_TYPES.BALANCE },
  { ...PRODUCT_TYPES.POSTPARTUM },
  { ...PRODUCT_TYPES.MEN },
];

//todo use productDataWith50 in podcast
export const productDataWith50: AtcProduct[] = [
  { ...PRODUCT_TYPES.WOMEN },
  { ...PRODUCT_TYPES.BALANCE },
  { ...PRODUCT_TYPES.POSTPARTUM },
  { ...PRODUCT_TYPES.MEN },
  { ...PRODUCT_TYPES.MEN50 },
];

export const productData2: AtcProduct[] = [
  { ...PRODUCT_TYPES.WOMEN },

  { ...PRODUCT_TYPES.BALANCE },
  { ...PRODUCT_TYPES.POSTPARTUM },
  { ...PRODUCT_TYPES.MEN },
];

export const productData3: AtcProduct[] = [
  { ...PRODUCT_TYPES.WOMEN },
  { ...PRODUCT_TYPES.BALANCE },
  { ...PRODUCT_TYPES.POSTPARTUM },
  { ...PRODUCT_TYPES.MEN },
  { ...PRODUCT_TYPES.MEN50 },
];

export const productDataMenAll: AtcProduct[] = [
  { ...PRODUCT_TYPES.MEN },
  { ...PRODUCT_TYPES.MEN50 },
];

/*
 * PROMO SKUS
 * The Transformer: Handles the "PROMO" suffix, the Men SKU hack, and the custom description
 */
const wrapPromo = (p: AtcProduct): AtcProduct => {
  const promo = {
    ...p,
    // fix for MENPRO1PROMO
    optionSkus: p.optionSkus.map((sku) =>
      `${sku}PROMO`.replace("MENPRO3", "MEN3").replace("MENPRO6", "MEN6")
    ),
  };

  // Inject the specific Men's Promo description
  if (["Men", "Men 50+"].includes(promo.id)) {
    promo.description =
      "Our physician-formulated, 100% drug-free daily hair growth supplements are made for men experiencing compromised hair health. Featuring vitamins, minerals, and natural ingredients to target root causes of thinning such as stress, lifestyle, and nutrition from within, without compromising sexual performance.<sup>1</sup>";
  }

  return promo;
};

export const productDataPromo = productData2.map(wrapPromo);
export const productDataPromoAll = productDataWith50.map(wrapPromo);
export const productDataMenPromoAll = [PRODUCT_TYPES.MEN, PRODUCT_TYPES.MEN50].map(wrapPromo);

export const productDataWomenThreeMonths = productDataPromo
  .filter((p) => !["Men", "Men 50+"].includes(p.id))
  .map((p) => ({ ...p, optionSkus: [p.optionSkus[1]] }));

/** 3-month women's core SKUs without *PROMO (e.g. ADV3, BAL3, POS3). */
export const productDataWomenThreeMonthsBase = productData2
  .filter((p) => !["Men", "Men 50+"].includes(p.id))
  .map((p) => ({ ...p, optionSkus: [p.optionSkus[1]] }));

export const productDataMenThreeMonths = productDataMenPromoAll.map((p) => ({
  ...p,
  optionSkus: [p.optionSkus[1]],
}));

export const productDataMenThreeMonthsBase = productDataMenAll.map((p) => ({
  ...p,
  optionSkus: [p.optionSkus[1]],
}));
